/**
 * Nombres de los eventos auditables, en castellano.
 *
 * Módulo aparte y sin JSX para poder probarlo con el ejecutor de tests de Node.
 * La lista tiene que quedar sincronizada con la del portal: si aparece un
 * evento nuevo allá y acá no, la pestaña lo muestra con su nombre técnico en
 * vez de romperse, que es la degradación correcta para una bitácora.
 */

export const EVENTOS_AUDITABLES = [
  'sesion.inicio',
  'sesion.inicio_fallido',
  'sesion.cierre',
  'sesion.bloqueada',
  'tenant.cambio',
  'tenant.cambio_denegado',
  'contrasena.cambio',
  'contrasena.cambio_fallido',
  'contrasena.recuperacion_solicitada',
  'contrasena.restablecida',
  'miembro.removido',
  'miembro.rol_cambiado',
  'datos.consulta',
  'datos.denegado',
] as const;

const ETIQUETAS: Record<string, string> = {
  'sesion.inicio': 'Inicio de sesión',
  'sesion.inicio_fallido': 'Intento fallido',
  'sesion.cierre': 'Cierre de sesión',
  'sesion.bloqueada': 'Cuenta bloqueada',
  'tenant.cambio': 'Cambio de empresa',
  'tenant.cambio_denegado': 'Cambio de empresa denegado',
  'contrasena.cambio': 'Cambio de contraseña',
  'contrasena.cambio_fallido': 'Cambio de contraseña fallido',
  'contrasena.recuperacion_solicitada': 'Recuperación solicitada',
  'contrasena.restablecida': 'Contraseña restablecida',
  'miembro.removido': 'Miembro quitado del equipo',
  'miembro.rol_cambiado': 'Rol de un miembro cambiado',
  'datos.consulta': 'Consulta de datos',
  'datos.denegado': 'Acceso denegado',
};

/** Nombre legible del evento. Uno desconocido se muestra tal cual, no se oculta. */
export function etiquetaDeEvento(evento: string): string {
  return ETIQUETAS[evento] ?? evento;
}
